"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _ColumnChartModule = _interopRequireDefault(require("./ColumnChart.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Type guard to check if series has data property

const ColumnChart = _ref => {
  let {
    isLoading,
    classNames,
    cardTitle,
    customExportOptions,
    series,
    drilldown,
    headerActions,
    hasEmptyData,
    emptyText,
    testId,
    ...userOptions
  } = _ref;
  const chartRef = /*#__PURE__*/React.createRef();
  const columnChartSeries = series.map((seriesItem, index) => ({
    ...seriesItem,
    name: seriesItem.name,
    data: seriesItem.data,
    color: (0, _charts.getDataVizColor)(index),
    pointWidth: _charts.columnPlotWidth
  }));
  const addColorToDrilldownSeries = series => series?.map(seriesItem => {
    // Type guard to check if series has data property
    const seriesWithData = seriesItem;
    return {
      ...seriesItem,
      ...(seriesWithData.data && {
        data: seriesWithData.data.map((dataItem, index) => ({
          ...dataItem,
          color: (0, _charts.getDataVizColor)(index),
          pointWidth: _charts.columnPlotWidth
        }))
      })
    };
  });
  const columnDrilldown = drilldown ? {
    ...drilldown,
    series: addColorToDrilldownSeries(drilldown.series),
    breadcrumbs: {
      floating: false
    }
  } : {};
  const defaultColumnChartOptions = (0, _charts.getColumnChartOptions)();
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultColumnChartOptions, {
    series: columnChartSeries,
    drilldown: columnDrilldown,
    ...userOptions
  });
  const {
    highChart,
    ...wrapperClassNames
  } = classNames || {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartWrapper.ChartWrapper, {
    isLoading: isLoading,
    title: cardTitle,
    ref: chartRef,
    classNames: wrapperClassNames,
    customExportOptions: customExportOptions,
    headerActions: headerActions,
    hasEmptyData: hasEmptyData,
    emptyText: emptyText,
    testId: testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_highchartsReactOfficial.default, {
      highcharts: _highcharts.default,
      containerProps: {
        className: (0, _classify.default)(_ColumnChartModule.default.columnChartContainer, highChart)
      },
      ref: chartRef,
      options: chartOptions
    })
  });
};
exports.ColumnChart = ColumnChart;